import { render, staticRenderFns } from "./MiddlePercentage.vue?vue&type=template&id=8efcaa20&scoped=true"
import script from "./MiddlePercentage.vue?vue&type=script&lang=js"
export * from "./MiddlePercentage.vue?vue&type=script&lang=js"
import style0 from "./MiddlePercentage.vue?vue&type=style&index=0&id=8efcaa20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efcaa20",
  null
  
)

export default component.exports